<template>
  <div v-if="!showStatic">
    <v-tabs slider-color="primary">
      <v-tab v-on:click="clearTable">{{ labels.search_all }}</v-tab>
      <v-tab v-on:click="clearTable">{{ labels.department }}</v-tab>
      <v-tab v-on:click="queryGeneralCourseInfo">{{ labels.general_course }}</v-tab>
      <v-tab v-on:click="queryPECourseInfo">{{ labels.pyhsical_course }}</v-tab>
      <v-tab v-on:click="queryChineseCourseInfo">{{labels.chinese_course}}</v-tab>
      <v-tab v-on:click="queryForeignCourseInfo">{{labels.foreign_course}}</v-tab>
      <v-tab v-on:click="queryTeacheInfo">{{ labels.teacher_course }}</v-tab>
      <v-tab v-on:click="clearTable">{{ labels.ntu_sys_course }}</v-tab>
      <v-tab v-if="select_language.lang == 'zh'" href="Files/課程查詢系統_操作手冊.pdf" target="_blank">{{
        labels.guideline
      }}</v-tab>
      <v-tab v-if="select_language.lang == 'en'" href="Files/CourseQuerySystemUserManual.pdf" target="_blank">
          {{ labels.guideline }}
      </v-tab>
      <v-tab-item>
        <TabAll />
      </v-tab-item>
      <v-tab-item>
        <TabDepartment />
      </v-tab-item>
      <v-tab-item>
        <TabGeneral ref="general" />
      </v-tab-item>
      <v-tab-item>
        <TabPE ref="PE" />
      </v-tab-item>
      <v-tab-item>
        <TabChinese ref="chinese" />
      </v-tab-item>
      <v-tab-item>
        <TabForeign ref="foreign" />
      </v-tab-item>
      <v-tab-item>
        <TabTeach ref="teach" />
      </v-tab-item>
      <v-tab-item><!-- 帶入台大的搜尋介面 -->
        <TabThreeCourse />
      </v-tab-item>
    </v-tabs>
  </div>
  <div v-else>
    <v-tabs slider-color="primary">
      <v-tab v-on:click="getStaticData('ntust_course.json')">{{
        labels.ntust_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('general_course.json')">{{
        labels.general_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('chinese_course.json')">{{
        labels.chinese_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('foreign_course.json')">{{
        labels.foreign_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('pyhsical_course.json')">{{
        labels.pyhsical_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('teacher_course.json')">{{
        labels.teacher_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('ntu_course.json')">{{
        labels.ntu_course
      }}</v-tab>
      <v-tab v-on:click="getStaticData('ntnu_course.json')">{{
        labels.ntnu_course
      }}</v-tab>
    </v-tabs>
    <br />
  </div>
</template>

<script>
import languages from "../languages/Tabs.json";

import TabAll from "../components/Tabs/TabAll";
import TabDepartment from "../components/Tabs/TabDepartment";
import TabGeneral from "../components/Tabs/TabGeneral";
import TabPE from "../components/Tabs/TabPE";
import TabChinese from "../components/Tabs/TabChinese";
import TabForeign from "../components/Tabs/TabForeign";
import TabThreeCourse from "../components/Tabs/TabThreeCourse";
import TabTeach from "../components/Tabs/TabTeach";

export default {
  components: {
    TabAll,
    TabDepartment,
    TabGeneral,
    TabPE,
    TabChinese,
    TabForeign,
    TabThreeCourse,
    TabTeach,
  },
  data: () => ({
    labels: {
      search_all: "",
      department: "",
      general_course: "",
      pyhsical_course: "",
      chinese_course: "",
      foreign_course: "",
      teacher_course: "",
      ntu_sys_course: "",
      guideline: "",
      ntu_course: "",
      ntnu_course: "",
      ntust_course: "",
    },
  }),

  computed: {
    select_language() {
      return this.$store.state.select_language;
    },
    showStatic() {
      return this.$store.state.showStatic;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    queryChineseCourseInfo: function() {
      return this.$refs.chinese.queryChineseCourseInfo();
    },
    queryForeignCourseInfo: function() {
      return this.$refs.foreign.queryForeignCourseInfo();
    },
    queryTeacheInfo: function() {
      return this.$refs.teach.queryTeacheInfo();
    },
    queryPECourseInfo: function() {
      return this.$refs.PE.queryPECourseInfo();
    },
    queryGeneralCourseInfo: function() {
      return this.$refs.general.queryGeneralCourseInfo();
    },
    clearTable: function() {
      this.$store.state.info = [];
    },
    setLanguage: function(select_language) {
      this.labels.search_all = languages.search_all[select_language.lang];
      this.labels.department = languages.department[select_language.lang];
      this.labels.general_course = languages.general_course[select_language.lang];
      this.labels.pyhsical_course = languages.pyhsical_course[select_language.lang];
      this.labels.chinese_course = languages.chinese_course[select_language.lang];
      this.labels.foreign_course = languages.foreign_course[select_language.lang];
      this.labels.teacher_course = languages.teacher_course[select_language.lang];
      this.labels.ntu_sys_course = languages.ntu_sys_course[select_language.lang];
      this.labels.guideline = languages.guideline[select_language.lang];
      this.labels.ntu_course = languages.ntu_course[select_language.lang];
      this.labels.ntnu_course = languages.ntnu_course[select_language.lang];
      this.labels.ntust_course = languages.ntust_course[select_language.lang];
    },
    getStaticData: function(file_name) {
      this.$store.dispatch("getStaticData", file_name);
    },
  },
};
</script>
